<script lang="ts">
  import OperationsManager from '@abrisojiffy/operations-manager'
  import Base from '@factry/base'
  import DowntimeManager from '@factry/downtime-manager'
  import EquipmentManager from '@factry/equipment-manager'
  import LabelManager from '@factry/label-manager'
  import MaterialManager from '@factry/material-manager'
  import MessageQueueManager from '@factry/message-queue-manager'
  import OrderManager from '@factry/order-manager'
  import WasteManager from '@factry/waste-manager'
</script>

<Base
  options={[
    OperationsManager, EquipmentManager, LabelManager, DowntimeManager,
    MessageQueueManager, OrderManager, MaterialManager, WasteManager,
  ]}
/>
